import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaTelegram,
  FaDiscord,
} from "react-icons/fa6";
import { IoIosArrowUp } from "react-icons/io";
import "./footer.scss";
import book2 from "../../assets/book_mockup.png";
const courseLinks = [
  "Анхан, дунд шат",
  "Шилжүүлэгч хөдөлгөөн",
  "Ойлгомжтой O1 хөдөлгөөн",
  "Толин тусгал хөдөлгөөн",
];

const supportLinks = [
  "Тэтгэлэг шалгуур",
  "Тэтгэлгийн хэмжээ",
  "Тэтгэлэг хүсэлт өгөх",
  "Удирдамж татах",
];

const companyLinks = [
  "Мэдээ, мэдээлэл",
  "Хамтран ажиллах",
  "Нийгмийн хариуцлага",
  "Холбоо барих",
];

const logo_white = require("../../assets/logo-white.png");

const Footer = () => {
  return (
    <footer className="siteFooter">
      <div className="siteFooter__main">
        <div className="siteFooter__container">
          <div className="siteFooter__grid">
            {/* Left brand section */}
            <div className="siteFooter__brand">
              <div className="siteFooter__logo">
                <img
                  src={logo_white}
                  alt="Ochiroo's Theory"
                  className="header-premium__brand__logo"
                />
              </div>

              <p className="siteFooter__desc">
                Чанартай, орчин үеийн, ойлгомжтой бүтэцтэй сургалтаар мэдлэгээ
                дараагийн түвшинд хүргээрэй.
              </p>

              <form
                className="siteFooter__subscribe"
                onSubmit={(e) => e.preventDefault()}
              >
                <input
                  type="text"
                  placeholder="Санал хүсэлт"
                  className="siteFooter__input"
                />
                <button type="submit" className="siteFooter__button">
                  илгээх
                </button>
              </form>

              <div className="siteFooter__socials">
                <a
                  href="https://www.facebook.com/ochiroo010101/"
                  aria-label="Facebook"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://www.instagram.com/ochiroo.ot/"
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://www.youtube.com/@ochirooot"
                  aria-label="Youtube"
                >
                  <FaYoutube />
                </a>
                <a href="https://t.me/ochirootrade" aria-label="Telegram">
                  <FaTelegram />
                </a>
                <a href="https://discord.gg/MArhZvyQ" aria-label="Discord">
                  <FaDiscord />
                </a>
              </div>
            </div>

            {/* Column 1 */}
            <div className="siteFooter__links mt-10">
              <h4>Сургалтууд</h4>
              <ul>
                {courseLinks.map((item) => (
                  <li key={item}>
                    <a href="/">{item}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 2 */}
            <div className="siteFooter__links mt-10">
              <h4 className="-mt-10">Тэтгэлэг</h4>
              <ul>
                {supportLinks.map((item) => (
                  <li key={item}>
                    <a href="/">{item}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 3 */}
            <div className="siteFooter__links mt-10">
              <h4>Бидний тухай</h4>
              <ul>
                {companyLinks.map((item) => (
                  <li key={item}>
                    <a href="/">{item}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right promo */}
            <div className="siteFooter__promo">
              {/* <div className="siteFooter__bookWrap">
                <div className="siteFooter__book">
                  <div className="siteFooter__bookTitle">OCHIROO’S</div>
                  <div className="siteFooter__bookSub">THEORY</div>
                  <div className="siteFooter__bookRing" />
                </div>
              </div> */}
              <div className="siteFooter__promo__image">
                <img src={book2} alt="book" />
              </div>
              <a
                href="https://www.amazon.com/Ochiroos-Theory-Financial-Freedom-Structure/dp/B0G5BFZXSM/ref=sr_1_1?crid=1C083B45K6U4W&dib=eyJ2IjoiMSJ9.a9bt0AqALTmnQs2mPkpyMQ.-L3Pb00wxiuXAtBjAjlN8rUeLscpGPfshDE_uDIZLWA&dib_tag=se&keywords=ochiroo&qid=1775497788&s=books&sprefix=ochiroo%2Cstripbooks-intl-ship%2C375&sr=1-1"
                target="_blank"
                rel="noopener noreferrer"
                className="siteFooter__amazon"
              >
                <span className="siteFooter__amazonText">amazon</span>
                <span className="siteFooter__amazonBuy">Buy</span>
              </a>
            </div>
          </div>
          <p className="text-[14px] mt-6 pr-[30%]">
            Эрсдэлийн сэрэмжлүүлэг: Форекс, CFD болон бусад өндөр xөшүүрэгтэй
            арилжаанд оролцогчдын 83% нь алдагдал хүлээдгийг судалгаанууд
            харуулдаг тул хөшүүрэгтэй арилжаанд орохоос өмнө хөрөнгөө алдах маш
            өндөр эрсдэлтэй болохыг анхаарна уу.
          </p>
          <p className="text-[14px] mt-6 pr-[30%]">
            Манай компани нь аливаа иргэн, хуулийн этгээдийн өмнө xөшүүрэгтэй
            арилжааны эрсдэл, алдагдал, бусад хохирлыг бүхэлд нь хариуцахгүй
            болно.
          </p>
        </div>
      </div>

      <div className="siteFooter__bottom">
        <div className="siteFooter__container siteFooter__bottomInner">
          <div className="siteFooter__copy">
            Ochiroo&apos;s theory © Оюуны өмчөөр хамгаалагдсан{" "}
            {new Date().getFullYear()} он
          </div>

          <button className="siteFooter__toTop" aria-label="Дээш очих">
            <IoIosArrowUp />
          </button>

          <div className="siteFooter__bottomLinks">
            <a href="/">Follow us</a>
            <a href="/">Privacy Policy</a>
            <a href="/">FAQs</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
